export const errorLevel = {
  INFO: 0, // will log, but not interrupt flow except between source and passError()
  WARN: 1, // will display a note to the user, but allow the app to continue
  BLOCK: 2, // Terminal error, prevent action beyond reload
  REAUTHENTICATE: 3 // Force reauthentication
};

export const errorDisplayTypes = {
  MODAL: 'MODAL',
  TOAST: 'TOAST'
};
